
export const fullcolor: string[] = [
    "000000",
    "252525",
    "343434",
    "4e4e4e",
    "686868",
    "757575",
    "8e8e8e",
    "a4a4a4",
    "b8b8b8",
    "c5c5c5",
    "d0d0d0",
    "d7d7d7",
    "e1e1e1",
    "eaeaea",
    "f4f4f4",
    "ffffff",
    "412000",
    "542800",
    "763700",
    "9a5000",
    "c36806",
    "e47b07",
    "ff911a",
    "ffab1d",
    "ffc51f",
    "ffd03b",
    "ffd84c",
    "ffe651",
    "fff456",
    "fff970",
    "ffff90",
    "ffffaa",
    "451904",
    "721e11",
    "9f241e",
    "b33a20",
    "c85120",
    "e36920",
    "fc8120",
    "fd8c25",
    "fe982c",
    "ffae38",
    "ffb946",
    "ffbf51",
    "ffc66d",
    "ffd587",
    "ffe498",
    "ffe6ab",
    "5d1f0c",
    "7a240d",
    "982c0e",
    "b02f0f",
    "bf3624",
    "d34e2a",
    "e7623e",
    "f36e4a",
    "fd7854",
    "ff8a6a",
    "ff987c",
    "ffa48b",
    "ffb39e",
    "ffc2b2",
    "ffd0c3",
    "ffdad0",
    "4a1700",
    "721f00",
    "a81300",
    "c8210a",
    "df2512",
    "ec3b24",
    "fa5236",
    "fc6148",
    "ff705f",
    "ff7e7e",
    "ff8f8f",
    "ff9d9e",
    "ffabad",
    "ffb9bd",
    "ffc7ce",
    "ffcade",
    "490036",
    "66004b",
    "80035f",
    "950f74",
    "aa2288",
    "ba3d99",
    "ca4da9",
    "d75ab6",
    "e467c3",
    "ef72ce",
    "fb7eda",
    "ff8de1",
    "ff9de5",
    "ffa5e7",
    "ffafea",
    "ffb8ec",
    "48036c",
    "5c0488",
    "650d90",
    "7b23a7",
    "933bbf",
    "9d45c9",
    "a74fd3",
    "b25ade",
    "bd65e9",
    "c56df1",
    "ce76fa",
    "d583ff",
    "da90ff",
    "de9cff",
    "e2a9ff",
    "e6b6ff",
    "051e81",
    "0626a5",
    "082fca",
    "263dd4",
    "444cde",
    "4f5aec",
    "5a68ff",
    "6575ff",
    "7183ff",
    "8091ff",
    "90a0ff",
    "97a9ff",
    "9fb2ff",
    "afbeff",
    "c0cbff",
    "cdd3ff",
    "0b0779",
    "201c8e",
    "3531a3",
    "4642b4",
    "5753c5",
    "615dcf",
    "6d69db",
    "7b77e9",
    "8985f7",
    "918dff",
    "9c98ff",
    "a7a4ff",
    "b2afff",
    "bbb8ff",
    "c3c1ff",
    "d3d1ff",
    "1d295a",
    "1d3876",
    "1d4892",
    "1d5cac",
    "1d71c6",
    "3286cf",
    "489bd9",
    "4ea8ec",
    "55b6ff",
    "69caff",
    "74cbff",
    "82d3ff",
    "8ddaff",
    "9fd4ff",
    "b4e2ff",
    "c0ebff",
    "004b59",
    "005d6e",
    "006f84",
    "00849c",
    "0099bf",
    "00abca",
    "00bcde",
    "00d0f5",
    "10dcff",
    "3ee1ff",
    "64e7ff",
    "76eaff",
    "8bedff",
    "9aefff",
    "b1f3ff",
    "c7f6ff",
    "004800",
    "005400",
    "036b03",
    "0e760e",
    "188018",
    "279227",
    "36a436",
    "4eb94e",
    "51cd51",
    "72da72",
    "7ce47c",
    "85ed85",
    "99f299",
    "b3f7b3",
    "c3f9c3",
    "cdfccd",
    "164000",
    "1c5300",
    "236600",
    "287800",
    "2e8c00",
    "3a980c",
    "47a519",
    "51af23",
    "5cba2e",
    "71cf43",
    "85e357",
    "8deb5f",
    "97f569",
    "a0fe72",
    "b1ff8a",
    "bcff9a",
    "2c3500",
    "384400",
    "445200",
    "495600",
    "607100",
    "6c7f00",
    "798d0a",
    "8b9f1c",
    "9eb22f",
    "abbf3c",
    "b8cc49",
    "c2d653",
    "cde153",
    "dbef6c",
    "e8fc79",
    "f2ffab",
    "463a09",
    "4d3f09",
    "544509",
    "6c5809",
    "907609",
    "ab8b0a",
    "c1a120",
    "d0b02f",
    "debe3d",
    "e6c645",
    "edcd4c",
    "f5d862",
    "fbe276",
    "fcee98",
    "fdf3a9",
    "fdf3be",
    "401a02",
    "581f05",
    "702408",
    "8d3a13",
    "ab511f",
    "b56427",
    "bf7730",
    "d0853a",
    "e19344",
    "eda04e",
    "f9ad58",
    "fcb75c",
    "ffc160",
    "ffca69",
    "ffcf7e",
    "ffda96"
]

export function getLengthOfColor() {
    return fullcolor.length;
}

export function getHexMapping(index: number) {
    return fullcolor[index];
}

export function getIndexIn128(hex: string) {
    return fullcolor.indexOf(hex);
}

export function listIndexIn128(hex: string[]) {
    return hex.map(getIndexIn128);
}

export function adjustBrightness(color: number, factor: number): number {
    let r = (color >> 16) & 0xff;
    let g = (color >> 8) & 0xff;
    let b = color & 0xff;

    r = Math.min(255, Math.max(0, r * factor));
    g = Math.min(255, Math.max(0, g * factor));
    b = Math.min(255, Math.max(0, b * factor));

    return (r << 16) | (g << 8) | b;
}